<template>
    <modal>
        <div slot="body" style="padding:.5em 1.5em;">
            <div class="title">
                {{$t("change_company")}}
            </div>
            <div class="field">
                <label>{{$t("company")}}</label>
                <span class="custom-dropdown"><select v-model="company">
                <option v-for="(comp, index) in userData.user.groups" :key="index" :value="comp.id">
                    {{comp.name}}
                </option>
                </select></span>
            </div>
            <button class="btn-green" @click="save()">{{$t('save')}}</button>
            <button class="btn-black" @click="$emit('close')">{{$t('cancel')}}</button>
        </div>
    </modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Modal from './../components/Modal'
export default {
  name: 'change-company',
  components: {Modal},
  mounted () {
    this.company = this._company
  },
  data () {
    return {
      company: 0
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      _company: state => state.auth.company
    })
  },
  methods: {
    ...mapActions({
      setCompany: 'auth/company'
    }),
    save () {
      this.setCompany(this.company)
      this.$router.go()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalCompany.vue